import { render, staticRenderFns } from "./DeleteOrderModal.vue?vue&type=template&id=b223b326&"
import script from "./DeleteOrderModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteOrderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports